import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { GRID_SIZE } from '@modules/artworks/artworks.constants';
import { useChangeGridSize } from '@hooks/useArtworks';

import SmallGridIcon from '../../../assets/images/grid-small.svg';
import MediumGridIcon from '../../../assets/images/grid-medium.svg';
import LargeGridIcon from '../../../assets/images/grid-large.svg';

import { gridSwitcherMessages } from './gridSwitcher.messages';
import { Container, Button, OuterContainer, Trigger } from './gridSwitcher.styles';

const GRID_MENU_DELAY = 100;

export const GridSwitcher = () => {
  const [showSizes, setShowSizes] = useState(false);
  const { gridSize, changeGridSize } = useChangeGridSize();
  const intl = useIntl();
  const smallCopy = intl.formatMessage(gridSwitcherMessages.small);
  const mediumCopy = intl.formatMessage(gridSwitcherMessages.medium);
  const largeCopy = intl.formatMessage(gridSwitcherMessages.large);

  const setGridSize = (gridSize: GRID_SIZE) => () => changeGridSize({ gridSize });

  const handleOpenGridMenu = () => {
    setTimeout(() => {
      setShowSizes(true);
    }, GRID_MENU_DELAY);
  };

  return (
    <OuterContainer onMouseLeave={() => setShowSizes(false)}>
      <Container isVisible={showSizes}>
        <Button
          active={gridSize === GRID_SIZE.SMALL}
          onClick={setGridSize(GRID_SIZE.SMALL)}
          aria-label={intl.formatMessage(gridSwitcherMessages.select, { size: smallCopy })}
        >
          <SmallGridIcon />
        </Button>
        <Button
          active={gridSize === GRID_SIZE.MEDIUM}
          onClick={setGridSize(GRID_SIZE.MEDIUM)}
          aria-label={intl.formatMessage(gridSwitcherMessages.select, { size: mediumCopy })}
        >
          <MediumGridIcon />
        </Button>
        <Button
          active={gridSize === GRID_SIZE.LARGE}
          onClick={setGridSize(GRID_SIZE.LARGE)}
          aria-label={intl.formatMessage(gridSwitcherMessages.select, { size: largeCopy })}
        >
          <LargeGridIcon />
        </Button>
      </Container>

      <Trigger active={false} onClick={handleOpenGridMenu} onMouseOver={handleOpenGridMenu}>
        <MediumGridIcon />
      </Trigger>
    </OuterContainer>
  );
};
